import {Component, Injector} from '@angular/core';
import {ProductParameterState, Store} from './state/store';
import {ProductParameter} from './state/model';
import {EntityListComponent} from '../../components/entity-list/component';
import {FilterService} from './filter.service';
import {ProductParameterQuery} from './state/query';
import {ProductParameterService} from './state/service';

@Component({
  templateUrl: '../../components/entity-list/component.html',
  styleUrls: ['../../components/entity-list/component.scss']
})
export class ProductParameterListComponent extends EntityListComponent<ProductParameter, ProductParameterState, Store> {

  translationDomain = 'productParameter';

  constructor(
    public injector: Injector,
    protected service: ProductParameterService,
    query: ProductParameterQuery,
    private ProductParameterFilterService: FilterService) {
    super(injector, service, query, ProductParameterFilterService);
  }
  canEdit(): boolean {
    return this.hasRole('ROLE_ADMIN');
  }
}
